import request from '@/request'

const state = {
	json: {
        // 列表和筛选
        tabeleTitle: '新药报告',
        secondlist: [],
        searchbox: [],
        newuptime: '',
        data: [],
        total: 0,
        // 详情
        res: {
            jbxx: {},
        },
        // 二次筛选状态：加载中
        ec_loding: false,
    },
    qs: {
        // 检索
        submit: {},
        // 筛选
        highest_status_cn: [],
        highest_status_en: [],
        targets: [],
        mesh_enames: [],
        mesh_enames2: [],
        yx: {},
        _yx: [],
    },
    // 临时选中的参数
    qs_tmp: {
        // 检索
        submit: {},
        // 筛选
        highest_status_cn: [],
        highest_status_en: [],
        targets: [],
        mesh_enames: [],
        mesh_enames2: [],
        _yx: [],
    },
    qs_random: 0, // 为了监听qs参数变化
}
const mutations = {
	setJson(state, payload) {
		state.json = payload;
	},
	setQs(state, payload) {
		state.qs = payload;
	},
	setQstmp(state, payload) {
		state.qs_tmp = payload;
	},
}
const actions = {
    // ######### 筛选、列表 ########
    // 设置检索
	async getSearch({ state, commit }) {
        await request.post('report/drugSearch')
        .then((val)=>{
			commit('setJson',{
                ...state.json,
                searchbox: val.data.searchbox,
            });
        })
        return true;
	},
    // 设置筛选
	async getFilter({ state, commit }) {
        state.json.ec_loding = true;
        await request.post('report/drugfilter', state.qs)
            .then((val) => {
                commit('setJson',{
                    ...state.json,
                    secondlist: val.data.secondlist,
                });
        })
        state.json.ec_loding = false;
        return true;
	},
	// 列表
	async getJson({ state,commit }) {
        await request.post('report/druglist', state.qs)
        .then((val)=>{
			commit('setJson',{
                ...state.json,
                data: val.data.lists,
                total: val.data.total,
                newuptime: val.data.newuptime,
            });
        })
	},
    // 重置筛选参数
    async resetFilter({ state }){
        if (state.qs._yx.length>0) {
            state.qs._yx.forEach((v) => {
                state.qs[v.name] = [];
            });
        }
        if (state.qs_tmp._yx.length>0) {
            state.qs_tmp._yx.forEach((v) => {
                state.qs_tmp[v.name] = [];
            });
        }
        state.qs._yx = [];
        state.qs_tmp._yx = [];
        state.qs.submit = {};
        state.qs_tmp.submit = {};
        state.qs.page = 1;
    },
    // 设置临时qs参数Qstmp
    setQstmp({ state },pm){
        const {v,vv,e,tp} = pm;
        if (e) {
            // 添加参数
            if(!state.qs_tmp[v['name']].includes(vv.value)){
                state.qs_tmp[v['name']].push(vv.value);
            }
            // 添加 _yx
            let isnew = false;
            state.qs_tmp._yx.forEach((item)=>{
                if (item.name == v.name) {
                    isnew = true;
                }
            })
            if (!isnew) {
                state.qs_tmp._yx.push(
                    {
                        label: v.label,
                        name: v.name,
                        value: [{label:vv.label,value:vv.value}],
                        scope: "ec",
                    }
                )
            }else{
                state.qs_tmp._yx.forEach((a,j) => {
                    if (a.name == v.name) {
                        const valuesArray = a.value.map(item => item.value);
                        if(!valuesArray.includes(vv.value)){
                            state.qs_tmp._yx[j].value.push({label:vv.label,value:vv.value});
                        }
                    }
                });
            }
        }else{
            // 删除参数
            if (typeof(tp)!='undefined') {
                state.qs_tmp[tp][v['name']] = "";
            }else{
                state.qs_tmp[v['name']] = state.qs_tmp[v['name']].filter(item=>item!=vv.value);
            }
            // 删除 _yx
            state.qs_tmp._yx.forEach((a,j) => {
                if (a.name == vv.name) {
                    state.qs_tmp._yx[j].value = state.qs_tmp._yx[j].value.filter(item=>item.value!=vv.value);
                }
                state.qs_tmp._yx = state.qs_tmp._yx.filter((item)=>item.value.length>0)
            });
        }
        state.qs.page = 1;
        state.qs = state.qs_tmp;
    },
    // ######### 详情 ########
	// 详情
    async getDetail({ state, commit }, oid) {
        await request.post('report/drugdetail', oid)
        .then((val) => {
			commit('setJson',{
                ...state.json,
                res: val.data,
            });
        })
	},
}

export default {
	state,
	mutations,
	actions
}
